import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import sharedStyles from 'components/shared-style'

const Title = ({ children, icon, theme }) => {
  const classes = sharedStyles(theme)

  return (
    <h1 className={classes.title}>
      {icon && <span className={classNames(classes.titleIcon, 'fal', `fa-${icon}`)} />}
      {children}
    </h1>
  )
}

Title.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
}

export default withTheme(Title)
